var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGemSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_663_3471)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.678711,
    width: 37.3625,
    height: 37.3625,
    rx: 9.34062,
    fill: "#6AD5FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.62732,
    cy: 14.7511,
    r: 27.7137,
    transform: "rotate(-0.403168 5.62732 14.7511)",
    fill: "url(#paint0_linear_663_3471)",
    stroke: "url(#paint1_linear_663_3471)",
    strokeWidth: 0.0572801
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.1171,
    cy: 34.5553,
    r: 27.7137,
    transform: "rotate(-0.403168 19.1171 34.5553)",
    fill: "url(#paint2_linear_663_3471)",
    stroke: "url(#paint3_radial_663_3471)",
    strokeWidth: 0.0572801
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.18541 15.6908H29.9273M13 8.41351L19.0564 15.6909L25.1229 8.41861M29.6809 15.1148L25.4627 8.78751C25.3565 8.6282 25.3034 8.54854 25.2333 8.49087C25.1711 8.43982 25.0996 8.40152 25.0226 8.37816C24.9357 8.35177 24.84 8.35177 24.6485 8.35177H13.4642C13.2727 8.35177 13.177 8.35177 13.0901 8.37816C13.0131 8.40152 12.9416 8.43982 12.8794 8.49087C12.8093 8.54854 12.7562 8.6282 12.65 8.78751L8.43179 15.1148C8.29352 15.3222 8.22438 15.4259 8.19961 15.5374C8.17772 15.636 8.18057 15.7384 8.20788 15.8356C8.23881 15.9456 8.31359 16.0453 8.46315 16.2447L18.2735 29.3252C18.5391 29.6793 18.6719 29.8563 18.8347 29.9196C18.9772 29.9751 19.1354 29.9751 19.278 29.9196C19.4408 29.8563 19.5736 29.6793 19.8392 29.3252L29.6495 16.2447C29.7991 16.0453 29.8739 15.9456 29.9048 15.8356C29.9321 15.7384 29.935 15.636 29.9131 15.5374C29.8883 15.4259 29.8192 15.3222 29.6809 15.1148Z",
    stroke: "white",
    strokeWidth: 1.33438,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_663_3471",
    x1: 5.62732,
    y1: -12.9913,
    x2: 5.62732,
    y2: 42.4934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_663_3471",
    x1: 34.6846,
    y1: 11.9929,
    x2: -29.5878,
    y2: 26.2329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2388FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2388FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_663_3471",
    x1: 19.1171,
    y1: 6.81289,
    x2: 19.1171,
    y2: 62.2976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2948A7",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2948A7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_663_3471",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.1171 34.5553) rotate(89.968) scale(57.4732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#7FC5FF",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FC5FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_663_3471"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.678711,
    width: 37.3625,
    height: 37.3625,
    rx: 9.34062,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGemSquare);
export default __webpack_public_path__ + "static/media/gemSquare.62621d95237399cb564e89fd81f5b592.svg";
export { ForwardRef as ReactComponent };